import React from 'react'


import style from './covenants-sub-sections.module.css'
import FilterMenu from '../../../../components/Global/FilterMenu/index.js'
import RoutinesContent from '../../../../components/Covenants/RoutinesContent/index.js'



const RoutinesExplore = (props) => {
  return (
  <>
    <RoutinesContent></RoutinesContent>
  </>
  )
}


export default RoutinesExplore
